export default __webpack_public_path__ + "d10ad6b8e8a72fccc5a490534b39a334.svg";